import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, unref as _unref, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "level-editor" }
const _hoisted_2 = { class: "level-overview" }
const _hoisted_3 = { class: "overview-left" }
const _hoisted_4 = { class: "level-title" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "cover-placeholder"
}
const _hoisted_8 = { class: "cover-overlay" }
const _hoisted_9 = {
  key: 0,
  class: "cover-error"
}
const _hoisted_10 = {
  key: 1,
  class: "cover-success"
}
const _hoisted_11 = { class: "facts" }
const _hoisted_12 = { class: "inline-list" }
const _hoisted_13 = { class: "overview-right" }
const _hoisted_14 = { class: "info-block" }
const _hoisted_15 = { class: "multiline" }
const _hoisted_16 = { class: "info-block" }
const _hoisted_17 = { class: "multiline" }
const _hoisted_18 = { class: "info-block" }
const _hoisted_19 = {
  key: 0,
  class: "chips"
}
const _hoisted_20 = {
  key: 1,
  class: "tag-placeholder"
}
const _hoisted_21 = { class: "info-block" }
const _hoisted_22 = { class: "gallery" }
const _hoisted_23 = ["title"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 0,
  class: "gallery-status"
}
const _hoisted_26 = {
  key: 1,
  class: "gallery-status error"
}
const _hoisted_27 = { class: "gallery-actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "cover-error"
}
const _hoisted_32 = { class: "info-block" }
const _hoisted_33 = {
  key: 0,
  class: "video-upload-item"
}
const _hoisted_34 = ["src", "poster"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 2,
  class: "cover-error"
}
const _hoisted_37 = { class: "tag-modal-content" }
const _hoisted_38 = { class: "tag-fieldset" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "tag-option-grid" }
const _hoisted_41 = ["value", "disabled"]
const _hoisted_42 = { class: "tag-fieldset" }
const _hoisted_43 = { class: "tag-option-grid" }
const _hoisted_44 = ["checked", "onChange"]
const _hoisted_45 = { class: "tag-fieldset" }
const _hoisted_46 = { class: "tag-option-grid" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "tag-fieldset" }
const _hoisted_49 = { class: "tag-option-grid" }
const _hoisted_50 = ["checked", "onChange"]
const _hoisted_51 = { class: "tag-modal-footer" }
const _hoisted_52 = {
  key: 0,
  class: "tag-modal-error",
  role: "alert"
}
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "language-editor" }
const _hoisted_55 = { class: "editor-heading" }
const _hoisted_56 = { class: "editor-heading-actions" }
const _hoisted_57 = { class: "selected-count" }
const _hoisted_58 = { class: "primary-language-row" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["value"]
const _hoisted_61 = {
  key: 1,
  class: "language-selection-error",
  role: "alert"
}
const _hoisted_62 = { class: "editor-layout" }
const _hoisted_63 = { class: "language-list" }
const _hoisted_64 = ["checked", "onChange"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "language-fields"
}
const _hoisted_67 = { class: "active-language" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "field-label-row" }
const _hoisted_70 = { class: "char-count" }
const _hoisted_71 = {
  key: 0,
  class: "field-error-msg",
  role: "alert"
}
const _hoisted_72 = { class: "field-label-row" }
const _hoisted_73 = { class: "char-count" }
const _hoisted_74 = {
  key: 0,
  class: "field-error-msg",
  role: "alert"
}
const _hoisted_75 = { class: "field-label-row" }
const _hoisted_76 = { class: "char-count" }
const _hoisted_77 = {
  key: 0,
  class: "field-error-msg",
  role: "alert"
}
const _hoisted_78 = {
  key: 1,
  class: "empty-editor"
}

import { computed, onBeforeUnmount, ref, watch } from "vue";
import {
  buildLanguageCsv,
  collectLanguageValidationIssues,
  formatLanguageValidationMessage,
  getLanguageFieldLimit,
  isLanguageFieldOverLimit,
  languageDisplayLabel,
  LANGUAGE_NATIVE_NAMES,
  parseLanguageCsv,
  type LanguageCsvField,
} from "./csvHelpers";
import { isObjectUrl } from "./zipHelpers";
import { resolveVideoAccessUrl } from "./videoHelpers";
import type {
  LevelDetailData,
  LevelImageInfo,
  LevelInfoData,
} from "./levelApiTypes";
import type {
  EditorDraftState,
  EditorExportState,
  LanguageDraft,
  TagDraft,
  TagItem,
} from "./zipTypes";

interface ConfigData {
  play_type?: TagItem[];
  play_cate?: Array<{
    play_cate: string;
    tag_name: string;
  }>;
  langs?: string[];
  devices_control?: TagItem[];
  tags?: TagItem[];
}

interface DisplayUploadItem {
  img_id: string;
  previewUrl: string;
  uploadedUrl: string;
  status: "uploading" | "success" | "error";
  error: string;
  file?: File;
  sourceId?: string;
  objectKey?: string;
  md5?: string;
}

interface VideoUploadItem {
  id: string;
  fileName: string;
  previewUrl: string;
  status: "uploading" | "success" | "error";
  error: string;
  file?: File;
  url?: string;
  sourceId?: string;
  objectKey?: string;
  md5?: string;
}

interface OriginalDisplayItem extends LevelImageInfo {
  key: string;
}

interface GalleryImageItem {
  key: string;
  img_id: string;
  previewUrl: string;
  status: "original" | DisplayUploadItem["status"];
  error: string;
  source: "original" | "upload";
}

const MAX_COVER_SIZE = 5 * 1024 * 1024;
const MAX_DISPLAY_IMAGES = 4;
const DEFAULT_DEVICE_TAG_ID = "80001";


export default /*@__PURE__*/_defineComponent({
  __name: 'LevelEditor',
  props: {
    config: {},
    detail: {},
    mediaBaseUrl: {},
    coverUploading: { type: Boolean },
    coverUploadError: {},
    uploadedCoverUrl: {},
    uploadedCoverRemoteUrl: {},
    coverFile: {},
    displayUploads: {},
    displayUploading: { type: Boolean },
    displayUploadError: {},
    videoUpload: {},
    videoUploading: { type: Boolean },
    videoUploadError: {}
  },
  emits: ["cover-selected", "display-images-selected", "display-image-removed", "video-selected", "video-removed", "tag-draft-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const ALLOWED_COVER_TYPES = new Set(["image/png", "image/jpeg"]);
const selectedLanguages = ref<string[]>([]);
const activeLanguage = ref("");
const primaryLanguage = ref("");
const languageSelectionError = ref("");
const languageDrafts = ref<Record<string, LanguageDraft>>({});
const coverInput = ref<HTMLInputElement | null>(null);
const coverPreviewUrl = ref("");
const localCoverFile = ref<File | null>(null);
const hideOriginalCover = ref(false);
const localCoverError = ref("");
const displayInput = ref<HTMLInputElement | null>(null);
const localDisplayError = ref("");
const videoInput = ref<HTMLInputElement | null>(null);
const localVideoError = ref("");
const previewImageUrl = ref("");
const originalDisplayImages = ref<OriginalDisplayItem[]>([]);
const originalVideoUrl = ref("");
const originalVideoCover = ref("");
const originalVideoId = ref("");
const tagEditorOpen = ref(false);
const tagEditorError = ref("");
const tagDraft = ref<TagDraft>({
  play_cate: "",
  devices_control: [],
  play_type: null,
  tags: [],
});
const editPlayCategory = ref("");
const editDeviceIds = ref<string[]>([]);
const editPlayTypeId = ref("");
const editTagIds = ref<string[]>([]);
const csvInput = ref<HTMLInputElement | null>(null);
const csvMessage = ref("");
const csvMessageKind = ref<"success" | "error" | "info">("info");

const detailData = computed(() => props.detail);
const configData = computed(() => (props.config || {}) as ConfigData);
const info = computed<LevelInfoData>(() => detailData.value.info_data || {});
const meta = computed(() => detailData.value.meta_data || {});
const playCategoryOptions = computed(() => configData.value.play_cate || []);
const deviceOptions = computed(() => configData.value.devices_control || []);
const playTypeOptions = computed(() => configData.value.play_type || []);
const tagOptions = computed(() => configData.value.tags || []);
const languageOptions = computed(() =>
  (configData.value.langs || []).map((code) => ({
    code,
    nativeName: languageLabel(code),
  })),
);
const canEditPlayCategory = computed(() => {
  const explicit = detailData.value.op_info?.allow_edit_play_cate;
  return explicit === undefined ? !meta.value.has_online_once : explicit;
});

const devices = computed(
  () => tagDraft.value.devices_control,
);

const displayUploads = computed(() => props.displayUploads || []);
const galleryImages = computed<GalleryImageItem[]>(() => [
  ...originalDisplayImages.value.map((image) => ({
    key: image.key,
    img_id: image.img_id,
    previewUrl: image.img_url,
    status: "original" as const,
    error: "",
    source: "original" as const,
  })),
  ...displayUploads.value.map((image) => ({
    key: `upload:${image.img_id}`,
    img_id: image.img_id,
    previewUrl: image.previewUrl,
    status: image.status,
    error: image.error,
    source: "upload" as const,
  })),
]);
const videoUpload = computed(() => props.videoUpload || null);
const videoStatusLabel = computed(() => {
  if (videoUpload.value?.status === "uploading") return "上传中";
  if (videoUpload.value?.status === "success") return "上传成功";
  return videoUpload.value?.error || "上传失败";
});
const displayVideo = computed(() => {
  if (videoUpload.value) {
    return {
      src: videoUpload.value.previewUrl,
      poster: "",
      title: videoUpload.value.fileName,
      status: videoUpload.value.status,
      statusLabel: videoStatusLabel.value,
      source: "upload" as const,
    };
  }

  if (!originalVideoUrl.value) return null;
  return {
    src: resolveVideoAccessUrl(originalVideoUrl.value, props.mediaBaseUrl),
    poster: originalVideoCover.value,
    title: "原展示视频",
    status: "original",
    statusLabel: "原视频",
    source: "original" as const,
  };
});
const displayCoverUrl = computed(
  () =>
    coverPreviewUrl.value ||
    props.uploadedCoverUrl ||
    (!hideOriginalCover.value ? info.value.cover_img?.img_url : "") ||
    "",
);

const playTypeName = computed(() => {
  const current = tagDraft.value.play_type;
  return (
    configData.value.play_type?.find(
      (item) => item.tag_id === current?.tag_id,
    )?.tag_name ||
    current?.tag_name ||
    "—"
  );
});

const playCategoryName = computed(
  () =>
    configData.value.play_cate?.find(
      (item) => item.play_cate === tagDraft.value.play_cate,
    )?.tag_name ||
    tagDraft.value.play_cate ||
    "—",
);

const tagSummary = computed(() => {
  const items: Array<{ key: string; name: string; primary: boolean }> = [];
  if (tagDraft.value.play_cate) {
    items.push({
      key: `category:${tagDraft.value.play_cate}`,
      name: playCategoryName.value,
      primary: true,
    });
  }
  for (const device of tagDraft.value.devices_control) {
    items.push({ key: `device:${device.tag_id}`, name: device.tag_name, primary: false });
  }
  if (tagDraft.value.play_type) {
    items.push({
      key: `type:${tagDraft.value.play_type.tag_id}`,
      name: playTypeName.value,
      primary: true,
    });
  }
  for (const tag of tagDraft.value.tags) {
    items.push({ key: `tag:${tag.tag_id}`, name: tag.tag_name, primary: false });
  }
  return items;
});

const playerCount = computed(() => {
  const raw = meta.value.player_count;
  if (!raw) return "—";

  const [minimum, maximum] = raw.split(",");
  return minimum === maximum || !maximum
    ? `${minimum} 人`
    : `${minimum}–${maximum} 人`;
});

const averageDuration = computed(() => {
  const seconds = Number(meta.value.pass_time);
  if (!Number.isFinite(seconds) || seconds < 0) return "—";

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}分${remainingSeconds.toString().padStart(2, "0")}秒`;
});

const performanceName = computed(() => {
  const names: Record<string, string> = {
    DEVICE_PERFORMANCE_LOW: "低",
    DEVICE_PERFORMANCE_MIDDLE: "中",
    DEVICE_PERFORMANCE_HIGH: "高",
  };
  return names[meta.value.device_performance || ""] || "—";
});

const activeDraft = computed(() =>
  activeLanguage.value
    ? languageDrafts.value[activeLanguage.value]
    : undefined,
);
const primaryDraft = computed(() =>
  primaryLanguage.value
    ? languageDrafts.value[primaryLanguage.value]
    : undefined,
);

watch(
  [() => props.detail, () => props.config],
  () => {
    clearCoverPreview();
    localCoverFile.value = null;
    hideOriginalCover.value = false;
    localCoverError.value = "";
    const source = detailData.value.info_data;
    originalDisplayImages.value = (source?.images || [])
      .filter((image) => Boolean(image.img_url))
      .slice(0, MAX_DISPLAY_IMAGES)
      .map((image, index) => ({
        ...image,
        key: `original:${image.img_id}:${index}`,
      }));
    originalVideoUrl.value = source?.video_info?.video_url || "";
    originalVideoCover.value = source?.video_info?.video_cover || "";
    originalVideoId.value = source?.video_info?.video_id || "";
    const online = detailData.value.online_data;
    const detailDevices =
      online?.online_devices_control ?? source?.devices_control ?? [];
    tagDraft.value = {
      play_cate: online?.online_play_cate ?? source?.play_cate ?? "",
      devices_control: detailDevices.length
        ? cloneTags(detailDevices)
        : cloneTags([
            deviceOptions.value.find(
              (item) => item.tag_id === DEFAULT_DEVICE_TAG_ID,
            ) || deviceOptions.value[0],
          ].filter((item): item is TagItem => Boolean(item))),
      play_type: cloneTag(online?.online_play_type ?? source?.play_type),
      tags: cloneTags(online?.online_tags ?? source?.tags ?? []),
    };
    emit("tag-draft-change", cloneTagDraft(tagDraft.value));
    if (!source) return;

    const drafts: Record<string, LanguageDraft> = {};
    for (const language of languageOptions.value) {
      const localized = source.multi_lang_info?.[language.code];
      const isDefault = language.code === source.default_lang;
      drafts[language.code] = {
        level_name:
          localized?.level_name || (isDefault ? source.level_name : "") || "",
        level_intro:
          localized?.level_intro || (isDefault ? source.level_intro : "") || "",
        desc: localized?.desc || (isDefault ? source.desc : "") || "",
        changelog: cloneChangelog(
          localized?.changelog ||
            (isDefault ? source.changelog : undefined) ||
            [],
        ),
        early_access_desc:
          localized?.early_access_desc ||
          (isDefault ? source.early_access_desc : "") ||
          "",
      };
    }

    languageDrafts.value = drafts;
    const configuredCodes = new Set(
      languageOptions.value.map((language) => language.code),
    );
    const savedLanguages = Object.keys(source.multi_lang_info || {}).filter(
      (code) => configuredCodes.has(code),
    );
    if (
      !savedLanguages.length &&
      source.default_lang &&
      configuredCodes.has(source.default_lang)
    ) {
      savedLanguages.push(source.default_lang);
    } else if (
      source.default_lang &&
      configuredCodes.has(source.default_lang) &&
      !savedLanguages.includes(source.default_lang)
    ) {
      savedLanguages.push(source.default_lang);
    }
    selectedLanguages.value = savedLanguages;
    primaryLanguage.value =
      source.default_lang && selectedLanguages.value.includes(source.default_lang)
        ? source.default_lang
        : selectedLanguages.value[0] || "";
    activeLanguage.value =
      primaryLanguage.value || selectedLanguages.value[0] || "";
    languageSelectionError.value = "";
  },
  { immediate: true },
);

watch(
  selectedLanguages,
  (languages) => {
    if (!languages.includes(activeLanguage.value)) {
      activeLanguage.value = languages[0] || "";
    }
    if (!languages.includes(primaryLanguage.value)) {
      primaryLanguage.value = languages[0] || "";
    }
  },
  { deep: true },
);

watch(primaryLanguage, (language) => {
  if (language && selectedLanguages.value.includes(language)) {
    activeLanguage.value = language;
  }
});

watch(
  () => props.coverUploadError,
  (error) => {
    if (error) clearCoverPreview();
  },
);

onBeforeUnmount(clearCoverPreview);

function openCoverPicker() {
  localCoverError.value = "";
  coverInput.value?.click();
}

function handleCoverChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = "";

  if (!file) return;

  if (!ALLOWED_COVER_TYPES.has(file.type)) {
    localCoverError.value = "仅支持 PNG、JPG 或 JPEG 图片。";
    return;
  }

  if (file.size > MAX_COVER_SIZE) {
    localCoverError.value = "封面图片不能超过 5 MiB。";
    return;
  }

  clearCoverPreview();
  localCoverError.value = "";
  localCoverFile.value = file;
  coverPreviewUrl.value = URL.createObjectURL(file);
  emit("cover-selected", file);
}

function openDisplayPicker() {
  localDisplayError.value = "";
  displayInput.value?.click();
}

function handleDisplayChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const selectedFiles = Array.from(input.files || []);
  input.value = "";
  localDisplayError.value = "";

  if (!selectedFiles.length) return;

  const slots = MAX_DISPLAY_IMAGES - galleryImages.value.length;
  if (selectedFiles.length > slots) {
    localDisplayError.value = `最多只能上传 ${MAX_DISPLAY_IMAGES} 张展示图片，本次仅处理前 ${slots} 张。`;
  }

  const files = selectedFiles.slice(0, slots);
  const invalidType = files.find((file) => !ALLOWED_COVER_TYPES.has(file.type));
  if (invalidType) {
    localDisplayError.value = `${invalidType.name}：仅支持 PNG、JPG 或 JPEG 图片。`;
    return;
  }

  const oversized = files.find((file) => file.size > MAX_COVER_SIZE);
  if (oversized) {
    localDisplayError.value = `${oversized.name}：图片不能超过 5 MiB。`;
    return;
  }

  emit("display-images-selected", files);
}

function removeDisplayImage(image: GalleryImageItem) {
  if (previewImageUrl.value === image.previewUrl) {
    previewImageUrl.value = "";
  }

  if (image.source === "original") {
    originalDisplayImages.value = originalDisplayImages.value.filter(
      (original) => original.key !== image.key,
    );
    localDisplayError.value = "";
    return;
  }

  emit("display-image-removed", image.img_id);
}

function openVideoPicker() {
  localVideoError.value = "";
  videoInput.value?.click();
}

function handleVideoChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = "";
  localVideoError.value = "";

  if (!file) return;
  if (file.type !== "video/mp4") {
    localVideoError.value = "仅支持 MP4 视频。";
    return;
  }

  emit("video-selected", file);
}

function removeDisplayedVideo() {
  localVideoError.value = "";
  if (displayVideo.value?.source === "upload") {
    emit("video-removed");
    return;
  }

  originalVideoUrl.value = "";
  originalVideoCover.value = "";
  originalVideoId.value = "";
}

function clearCoverPreview() {
  if (coverPreviewUrl.value) {
    URL.revokeObjectURL(coverPreviewUrl.value);
    coverPreviewUrl.value = "";
  }
}

function selectLanguage(code: string) {
  if (!selectedLanguages.value.includes(code)) {
    selectedLanguages.value.push(code);
  }
  languageSelectionError.value = "";
  activeLanguage.value = code;
}

function toggleLanguage(code: string, event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  if (checked) {
    if (!selectedLanguages.value.includes(code)) {
      selectedLanguages.value.push(code);
    }
    if (!primaryLanguage.value) primaryLanguage.value = code;
    activeLanguage.value = code;
    languageSelectionError.value = "";
    return;
  }
  if (code === primaryLanguage.value) {
    (event.target as HTMLInputElement).checked = true;
    languageSelectionError.value = "请先切换主要语言，再取消该语言。";
    return;
  }
  selectedLanguages.value = selectedLanguages.value.filter(
    (language) => language !== code,
  );
  languageSelectionError.value = "";
}

function languageLabel(code: string) {
  return LANGUAGE_NATIVE_NAMES[code] || code;
}

function fieldLimit(field: LanguageCsvField) {
  return getLanguageFieldLimit(field);
}

function isFieldOverLimit(field: LanguageCsvField, value: string) {
  return isLanguageFieldOverLimit(field, value);
}

function validateLanguageDraftLimits(languages = selectedLanguages.value) {
  return collectLanguageValidationIssues(languages, languageDrafts.value);
}

function openCsvUpload() {
  csvMessage.value = "";
  csvInput.value?.click();
}

function downloadLanguageCsv() {
  csvMessage.value = "";
  const languages = languageOptions.value.map((language) => language.code);
  if (!languages.length) {
    csvMessageKind.value = "error";
    csvMessage.value = "当前配置未提供可用语言列表。";
    return;
  }

  const drafts: Record<string, LanguageDraft> = {};
  for (const code of languages) {
    drafts[code] = languageDrafts.value[code]
      ? {
          ...languageDrafts.value[code],
          changelog: cloneChangelog(languageDrafts.value[code].changelog || []),
        }
      : {
          level_name: "",
          level_intro: "",
          desc: "",
          changelog: [],
          early_access_desc: "",
        };
  }

  const csv = buildLanguageCsv(languages, drafts, languageDisplayLabel);
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const levelId = detailData.value.level_id || "level";
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  const anchor = document.createElement("a");
  const url = URL.createObjectURL(blob);
  anchor.href = url;
  anchor.download = `oversea-i18n-${levelId}-${timestamp}.csv`;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
  csvMessageKind.value = "success";
  csvMessage.value = `已导出 ${languages.length} 种语言的 CSV 草稿。`;
}

async function handleCsvUpload(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = "";
  csvMessage.value = "";

  if (!file) return;

  try {
    const text = await file.text();
    const knownLanguages = languageOptions.value.map((language) => language.code);
    if (!knownLanguages.length) {
      throw new Error("当前配置未提供可用语言列表。");
    }

    const drafts: Record<string, LanguageDraft> = {};
    for (const code of knownLanguages) {
      const existing = languageDrafts.value[code];
      drafts[code] = existing
        ? {
            ...existing,
            changelog: cloneChangelog(existing.changelog || []),
          }
        : {
            level_name: "",
            level_intro: "",
            desc: "",
            changelog: [],
            early_access_desc: "",
          };
    }

    const result = parseLanguageCsv(
      text,
      knownLanguages,
      languageDisplayLabel,
      drafts,
    );
    languageDrafts.value = drafts;

    for (const code of result.appliedLanguages) {
      if (!selectedLanguages.value.includes(code)) {
        selectedLanguages.value.push(code);
      }
    }
    if (!primaryLanguage.value && selectedLanguages.value.length) {
      primaryLanguage.value = selectedLanguages.value[0];
    }
    if (
      activeLanguage.value &&
      !result.appliedLanguages.includes(activeLanguage.value) &&
      result.appliedLanguages.length
    ) {
      activeLanguage.value = result.appliedLanguages[0];
    }
    languageSelectionError.value = "";

    const parts = [
      `已应用 ${result.appliedLanguages.length} 种语言。`,
      ...result.warnings,
    ];
    csvMessageKind.value = result.warnings.length ? "info" : "success";
    csvMessage.value = parts.join(" ");
  } catch (error) {
    csvMessageKind.value = "error";
    csvMessage.value =
      error instanceof Error ? error.message : "CSV 导入失败。";
  }
}

function openTagEditor() {
  editPlayCategory.value = tagDraft.value.play_cate;
  editDeviceIds.value = tagDraft.value.devices_control.map((item) => item.tag_id);
  editPlayTypeId.value = tagDraft.value.play_type?.tag_id || "";
  editTagIds.value = tagDraft.value.tags.map((item) => item.tag_id).slice(0, 6);
  tagEditorError.value = "";
  tagEditorOpen.value = true;
}

function closeTagEditor() {
  tagEditorOpen.value = false;
  tagEditorError.value = "";
}

function toggleDevice(id: string) {
  editDeviceIds.value = toggleId(editDeviceIds.value, id);
  tagEditorError.value = "";
}

function toggleExtraTag(id: string) {
  if (editTagIds.value.includes(id)) {
    editTagIds.value = editTagIds.value.filter((item) => item !== id);
    tagEditorError.value = "";
    return;
  }
  if (editTagIds.value.length >= 6) {
    tagEditorError.value = "更多标签最多可选择 6 个。";
    return;
  }
  editTagIds.value = [...editTagIds.value, id];
  tagEditorError.value = "";
}

function confirmTagDraft() {
  const selectedDevices = filterTags(deviceOptions.value, editDeviceIds.value);
  if (!selectedDevices.length) {
    tagEditorError.value = "请至少选择一个控制设备。";
    return;
  }
  if (!editPlayTypeId.value) {
    tagEditorError.value = "请选择一个玩法类型。";
    return;
  }
  if (editTagIds.value.length > 6) {
    tagEditorError.value = "更多标签最多可选择 6 个。";
    return;
  }

  const nextDraft: TagDraft = {
    play_cate: canEditPlayCategory.value
      ? editPlayCategory.value
      : tagDraft.value.play_cate,
    devices_control: selectedDevices,
    play_type:
      cloneTag(
        playTypeOptions.value.find((item) => item.tag_id === editPlayTypeId.value),
      ) || null,
    tags: filterTags(tagOptions.value, editTagIds.value),
  };
  tagDraft.value = nextDraft;
  emit("tag-draft-change", cloneTagDraft(nextDraft));
  closeTagEditor();
}

function toggleId(ids: string[], id: string) {
  return ids.includes(id) ? ids.filter((item) => item !== id) : [...ids, id];
}

function filterTags(options: TagItem[], ids: string[]) {
  return ids
    .map((id) => options.find((item) => item.tag_id === id))
    .filter((item): item is TagItem => Boolean(item))
    .map((item) => ({ ...item }));
}

function cloneTag(item?: TagItem | null) {
  return item ? { ...item } : null;
}

function cloneTags(items: TagItem[]) {
  return items.map((item) => ({ ...item }));
}

function cloneTagDraft(draft: TagDraft): TagDraft {
  return {
    play_cate: draft.play_cate,
    devices_control: cloneTags(draft.devices_control),
    play_type: cloneTag(draft.play_type),
    tags: cloneTags(draft.tags),
  };
}

function getExportState(): EditorExportState {
  const drafts: Record<string, LanguageDraft> = {};
  for (const language of languageOptions.value) {
    drafts[language.code] = languageDrafts.value[language.code]
      ? {
          ...languageDrafts.value[language.code],
          changelog: cloneChangelog(
            languageDrafts.value[language.code].changelog || [],
          ),
        }
      : {
          level_name: "",
          level_intro: "",
          desc: "",
          changelog: [],
          early_access_desc: "",
        };
  }
  const coverFile = props.coverFile || localCoverFile.value;
  const cover = coverFile
    ? {
        label: "封面",
        file: coverFile,
        fileName: coverFile.name,
        mimeType: coverFile.type,
        remoteUrl: props.uploadedCoverRemoteUrl || undefined,
      }
    : props.uploadedCoverRemoteUrl &&
        !isObjectUrl(props.uploadedCoverRemoteUrl)
      ? {
          label: "封面",
          remoteUrl: props.uploadedCoverRemoteUrl,
          fileName: fileNameFromUrl(props.uploadedCoverRemoteUrl, "cover"),
        }
    : !hideOriginalCover.value &&
        info.value.cover_img?.img_url &&
        !isObjectUrl(info.value.cover_img.img_url)
      ? {
          label: "封面",
          remoteUrl: info.value.cover_img.img_url,
          sourceId: info.value.cover_img.img_id,
          fileName: fileNameFromUrl(info.value.cover_img.img_url, "cover"),
        }
      : null;
  const displayImages = galleryImages.value.map((image, index) => {
    if (image.source === "original") {
      return {
        label: `展示图片 ${index + 1}`,
        remoteUrl: image.previewUrl,
        sourceId: image.img_id,
        fileName: fileNameFromUrl(image.previewUrl, `display-${index + 1}`),
      };
    }
    const upload = displayUploads.value.find((item) => item.img_id === image.img_id);
    return upload?.file
      ? {
          label: `展示图片 ${index + 1}`,
          file: upload.file,
          fileName: upload.file.name,
          mimeType: upload.file.type,
          remoteUrl: upload.uploadedUrl || undefined,
          sourceId: upload.sourceId,
          objectKey: upload.objectKey,
          md5: upload.md5,
        }
      : {
          label: `展示图片 ${index + 1}`,
          remoteUrl: upload?.uploadedUrl || undefined,
          sourceId: upload?.sourceId,
          objectKey: upload?.objectKey,
          md5: upload?.md5,
          fileName: fileNameFromUrl(upload?.uploadedUrl || "", `display-${index + 1}`),
        };
  });
  const currentVideo = videoUpload.value;
  const video = currentVideo?.file
    ? {
        label: "展示视频",
        file: currentVideo.file,
        fileName: currentVideo.file.name,
        mimeType: currentVideo.file.type,
        remoteUrl: currentVideo.url || undefined,
        sourceId: currentVideo.sourceId,
        objectKey: currentVideo.objectKey,
        md5: currentVideo.md5,
      }
    : currentVideo?.url && !isObjectUrl(currentVideo.url)
      ? {
          label: "展示视频",
          remoteUrl: currentVideo.url,
          fileName: currentVideo.fileName,
          mimeType: "video/mp4",
          sourceId: currentVideo.sourceId,
          objectKey: currentVideo.objectKey,
          md5: currentVideo.md5,
        }
      : originalVideoUrl.value
        ? {
            label: "展示视频",
            remoteUrl: originalVideoUrl.value,
            fileName: fileNameFromUrl(originalVideoUrl.value, "video.mp4"),
            mimeType: "video/mp4",
            sourceId: originalVideoId.value || undefined,
          }
        : null;

  return {
    tags: cloneTagDraft(tagDraft.value),
    selectedLanguages: [...selectedLanguages.value],
    defaultLang: primaryLanguage.value,
    drafts,
    cover,
    displayImages,
    video,
  };
}

function applyImportedDrafts(state: EditorDraftState) {
  const importedTags = cloneTagDraft(state.tags);
  if (!canEditPlayCategory.value) {
    importedTags.play_cate = tagDraft.value.play_cate;
  }
  tagDraft.value = importedTags;
  emit("tag-draft-change", cloneTagDraft(tagDraft.value));
  const drafts: Record<string, LanguageDraft> = {};
  for (const language of languageOptions.value) {
    const imported = state.drafts[language.code];
    drafts[language.code] = imported
      ? {
          ...imported,
          changelog: cloneChangelog(imported.changelog || []),
        }
      : {
          level_name: "",
          level_intro: "",
          desc: "",
          changelog: [],
          early_access_desc: "",
        };
  }
  languageDrafts.value = drafts;
  const configuredCodes = new Set(
    languageOptions.value.map((language) => language.code),
  );
  selectedLanguages.value = state.selectedLanguages.filter((code) =>
    configuredCodes.has(code),
  );
  primaryLanguage.value =
    state.defaultLang && selectedLanguages.value.includes(state.defaultLang)
      ? state.defaultLang
      : selectedLanguages.value[0] || "";
  activeLanguage.value = primaryLanguage.value;
  languageSelectionError.value = "";
}

function clearOriginalMediaForImport() {
  clearCoverPreview();
  localCoverFile.value = null;
  hideOriginalCover.value = true;
  originalDisplayImages.value = [];
  originalVideoUrl.value = "";
  originalVideoCover.value = "";
  originalVideoId.value = "";
  previewImageUrl.value = "";
}

function clearOriginalCoverForImport() {
  clearCoverPreview();
  localCoverFile.value = null;
  hideOriginalCover.value = true;
}

function clearOriginalDisplayForImport() {
  originalDisplayImages.value = [];
  previewImageUrl.value = "";
}

function clearOriginalVideoForImport() {
  originalVideoUrl.value = "";
  originalVideoCover.value = "";
  originalVideoId.value = "";
}

function cloneChangelog(
  items: Array<{ version_id?: string; edition?: string; content?: string }>,
) {
  return items.map((item) => ({
    version_id: item.version_id || "",
    edition: item.edition || "",
    content: item.content || "",
  }));
}

function fileNameFromUrl(url: string, fallback: string) {
  try {
    return decodeURIComponent(new URL(url).pathname.split("/").pop() || fallback);
  } catch {
    return fallback;
  }
}

__expose({
  getExportState,
  applyImportedDrafts,
  clearOriginalMediaForImport,
  clearOriginalCoverForImport,
  clearOriginalDisplayForImport,
  clearOriginalVideoForImport,
  validateLanguageDraftLimits,
  formatLanguageValidationMessage: (issues: ReturnType<typeof collectLanguageValidationIssues>) =>
    formatLanguageValidationMessage(issues, languageDisplayLabel),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(primaryDraft.value?.level_name || "未命名关卡"), 1),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "edit-mark" }, "✎", -1))
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "section-label" }, "✦ 关卡封面", -1)),
        _createElementVNode("button", {
          class: "cover-picker",
          type: "button",
          disabled: __props.coverUploading,
          onClick: openCoverPicker
        }, [
          (displayCoverUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "cover-image",
                src: displayCoverUrl.value,
                alt: primaryDraft.value?.level_name || '关卡封面'
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "暂无封面")),
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.coverUploading ? "正在上传…" : "点击更换封面"), 1)
        ], 8, _hoisted_5),
        _createElementVNode("input", {
          ref_key: "coverInput",
          ref: coverInput,
          class: "file-input",
          type: "file",
          accept: "image/png,image/jpeg,.jpg,.jpeg,.png",
          onChange: handleCoverChange
        }, null, 544),
        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "cover-hint" }, "支持 PNG、JPG、JPEG，文件不超过 5 MiB", -1)),
        (localCoverError.value || __props.coverUploadError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(localCoverError.value || __props.coverUploadError), 1))
          : (__props.uploadedCoverRemoteUrl)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 封面上传成功 "))
            : _createCommentVNode("", true),
        _createElementVNode("dl", _hoisted_11, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("dt", null, "游玩人数", -1)),
            _createElementVNode("dd", null, _toDisplayString(playerCount.value), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "控制设备", -1)),
            _createElementVNode("dd", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (device) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: device.tag_id
                }, _toDisplayString(device.tag_name), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("dt", null, "玩法类型", -1)),
            _createElementVNode("dd", null, _toDisplayString(playTypeName.value), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "玩法分类", -1)),
            _createElementVNode("dd", null, _toDisplayString(playCategoryName.value), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("dt", null, "平均时长", -1)),
            _createElementVNode("dd", null, _toDisplayString(averageDuration.value), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("dt", null, "负载要求", -1)),
            _createElementVNode("dd", null, _toDisplayString(performanceName.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-label" }, "✦ 玩法说明", -1)),
          _createElementVNode("p", _hoisted_15, _toDisplayString(primaryDraft.value?.level_intro || "暂无玩法说明"), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "section-label" }, "✦ 关卡详情", -1)),
          _createElementVNode("p", _hoisted_17, _toDisplayString(primaryDraft.value?.desc || "暂无关卡详情"), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "section-label" }, "✦ 关卡标签", -1)),
          _createElementVNode("button", {
            class: "tag-editor-trigger",
            type: "button",
            "aria-haspopup": "dialog",
            onClick: openTagEditor
          }, [
            (tagSummary.value.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagSummary.value, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: item.key,
                      class: _normalizeClass(['chip', { 'chip-primary': item.primary }])
                    }, _toDisplayString(item.name), 3))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "点击添加关卡标签")),
            _cache[19] || (_cache[19] = _createElementVNode("span", {
              class: "tag-edit-icon",
              "aria-hidden": "true"
            }, "✎", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "section-label" }, "✦ 展示图片", -1)),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleryImages.value, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.key,
                class: "gallery-item",
                title: image.error
              }, [
                _createElementVNode("img", {
                  src: image.previewUrl,
                  alt: "关卡展示图片"
                }, null, 8, _hoisted_24),
                (image.status === 'uploading')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, " 正在上传… "))
                  : (image.status === 'error')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " 上传失败 "))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (previewImageUrl.value = image.previewUrl)
                  }, " 放大 ", 8, _hoisted_28),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (removeDisplayImage(image))
                  }, " 删除 ", 8, _hoisted_29)
                ])
              ], 8, _hoisted_23))
            }), 128)),
            (galleryImages.value.length < MAX_DISPLAY_IMAGES)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "gallery-add",
                  type: "button",
                  disabled: __props.displayUploading,
                  "aria-label": "添加展示图片",
                  onClick: openDisplayPicker
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", null, "＋", -1)),
                  _createElementVNode("small", null, _toDisplayString(__props.displayUploading ? "上传中" : "添加图片"), 1)
                ], 8, _hoisted_30))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("input", {
            ref_key: "displayInput",
            ref: displayInput,
            class: "file-input",
            type: "file",
            accept: "image/png,image/jpeg,.jpg,.jpeg,.png",
            multiple: "",
            onChange: handleDisplayChange
          }, null, 544),
          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "cover-hint" }, "最多 4 张；支持 PNG、JPG、JPEG，单张不超过 5 MiB", -1)),
          (localDisplayError.value || __props.displayUploadError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(localDisplayError.value || __props.displayUploadError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "section-label" }, "✦ 展示视频", -1)),
          (displayVideo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("video", {
                  src: displayVideo.value.src,
                  poster: displayVideo.value.poster || undefined,
                  controls: "",
                  preload: "metadata"
                }, null, 8, _hoisted_34),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(displayVideo.value.title), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(['video-status', displayVideo.value.status])
                  }, _toDisplayString(displayVideo.value.statusLabel), 3),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: removeDisplayedVideo
                  }, "删除")
                ])
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "video-picker",
                type: "button",
                disabled: __props.videoUploading,
                onClick: openVideoPicker
              }, " 选择 MP4 视频 ", 8, _hoisted_35)),
          _createElementVNode("input", {
            ref_key: "videoInput",
            ref: videoInput,
            class: "file-input",
            type: "file",
            accept: "video/mp4,.mp4",
            onChange: handleVideoChange
          }, null, 544),
          _cache[25] || (_cache[25] = _createElementVNode("p", { class: "cover-hint" }, "仅支持单个 MP4 视频", -1)),
          (localVideoError.value || __props.videoUploadError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(localVideoError.value || __props.videoUploadError), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (tagEditorOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "tag-modal-backdrop",
            role: "presentation",
            onClick: _withModifiers(closeTagEditor, ["self"]),
            onKeydown: _withKeys(closeTagEditor, ["esc"])
          }, [
            _createElementVNode("form", {
              class: "tag-modal",
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": "tag-modal-title",
              onSubmit: _withModifiers(confirmTagDraft, ["prevent"])
            }, [
              _createElementVNode("header", { class: "tag-modal-header" }, [
                _cache[26] || (_cache[26] = _createElementVNode("h2", { id: "tag-modal-title" }, "关卡标签", -1)),
                _createElementVNode("button", {
                  class: "tag-modal-close",
                  type: "button",
                  "aria-label": "关闭关卡标签弹窗",
                  onClick: closeTagEditor
                }, " × ")
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("fieldset", _hoisted_38, [
                  _createElementVNode("legend", null, [
                    _cache[27] || (_cache[27] = _createTextVNode(" ✦ 游玩分类 ", -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("span", { "aria-hidden": "true" }, "*", -1)),
                    (!canEditPlayCategory.value)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_39, "首次发布后不可修改"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playCategoryOptions.value, (category) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: category.play_cate,
                        class: _normalizeClass([
                    'tag-option',
                    { selected: editPlayCategory.value === category.play_cate, disabled: !canEditPlayCategory.value },
                  ])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editPlayCategory).value = $event)),
                          type: "radio",
                          name: "play-category",
                          value: category.play_cate,
                          disabled: !canEditPlayCategory.value
                        }, null, 8, _hoisted_41), [
                          [_vModelRadio, editPlayCategory.value]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(category.tag_name), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_42, [
                  _cache[29] || (_cache[29] = _createElementVNode("legend", null, [
                    _createTextVNode("✦ 控制设备 "),
                    _createElementVNode("span", { "aria-hidden": "true" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceOptions.value, (device) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: device.tag_id,
                        class: _normalizeClass(['tag-option', { selected: editDeviceIds.value.includes(device.tag_id) }])
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: editDeviceIds.value.includes(device.tag_id),
                          onChange: ($event: any) => (toggleDevice(device.tag_id))
                        }, null, 40, _hoisted_44),
                        _createElementVNode("span", null, _toDisplayString(device.tag_name), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_45, [
                  _cache[30] || (_cache[30] = _createElementVNode("legend", null, [
                    _createTextVNode("✦ 玩法类型 "),
                    _createElementVNode("span", { "aria-hidden": "true" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playTypeOptions.value, (playType) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: playType.tag_id,
                        class: _normalizeClass(['tag-option', { selected: editPlayTypeId.value === playType.tag_id }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editPlayTypeId).value = $event)),
                          type: "radio",
                          name: "play-type",
                          value: playType.tag_id
                        }, null, 8, _hoisted_47), [
                          [_vModelRadio, editPlayTypeId.value]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(playType.tag_name), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_48, [
                  _createElementVNode("legend", null, "✦ 更多标签（" + _toDisplayString(editTagIds.value.length) + "/6）", 1),
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOptions.value, (tag) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: tag.tag_id,
                        class: _normalizeClass(['tag-option', { selected: editTagIds.value.includes(tag.tag_id) }])
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: editTagIds.value.includes(tag.tag_id),
                          onChange: ($event: any) => (toggleExtraTag(tag.tag_id))
                        }, null, 40, _hoisted_50),
                        _createElementVNode("span", null, _toDisplayString(tag.tag_name), 1)
                      ], 2))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_51, [
                (tagEditorError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(tagEditorError.value), 1))
                  : _createCommentVNode("", true),
                _cache[31] || (_cache[31] = _createElementVNode("button", {
                  class: "tag-confirm-button",
                  type: "submit"
                }, "确认", -1))
              ])
            ], 32)
          ], 32))
        : _createCommentVNode("", true),
      (previewImageUrl.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "image-preview",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "展示图片预览",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (previewImageUrl.value = ''), ["self"]))
          }, [
            _createElementVNode("button", {
              type: "button",
              "aria-label": "关闭预览",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (previewImageUrl.value = ''))
            }, " × "),
            _createElementVNode("img", {
              src: previewImageUrl.value,
              alt: "展示图片大图预览"
            }, null, 8, _hoisted_53)
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("section", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _cache[32] || (_cache[32] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow" }, "MULTI-LANGUAGE EDITOR"),
          _createElementVNode("h3", null, "十五语内容编辑")
        ], -1)),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("span", _hoisted_57, " 已选择 " + _toDisplayString(selectedLanguages.value.length) + " 种语言 ", 1),
          _createElementVNode("div", { class: "csv-actions" }, [
            _createElementVNode("button", {
              class: "csv-button",
              type: "button",
              onClick: downloadLanguageCsv
            }, " 下载 CSV "),
            _createElementVNode("button", {
              class: "csv-button",
              type: "button",
              onClick: openCsvUpload
            }, " 上传 CSV ")
          ])
        ])
      ]),
      _createElementVNode("input", {
        ref_key: "csvInput",
        ref: csvInput,
        class: "file-input",
        type: "file",
        accept: ".csv,text/csv",
        onChange: handleCsvUpload
      }, null, 544),
      (csvMessage.value)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(['csv-message', csvMessageKind.value]),
            role: "status"
          }, _toDisplayString(csvMessage.value), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_58, [
        _cache[33] || (_cache[33] = _createElementVNode("label", { for: "primary-language" }, "主要语言", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "primary-language",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((primaryLanguage).value = $event)),
          disabled: !selectedLanguages.value.length
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLanguages.value, (code) => {
            return (_openBlock(), _createElementBlock("option", {
              key: code,
              value: code
            }, _toDisplayString(_unref(languageDisplayLabel)(code)), 9, _hoisted_60))
          }), 128))
        ], 8, _hoisted_59), [
          [_vModelSelect, primaryLanguage.value]
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("span", null, "标题、玩法说明、关卡详情及最终上传均以此语言为准", -1))
      ]),
      (languageSelectionError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(languageSelectionError.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("aside", _hoisted_63, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageOptions.value, (language) => {
            return (_openBlock(), _createElementBlock("label", {
              key: language.code,
              class: _normalizeClass({ active: activeLanguage.value === language.code })
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: selectedLanguages.value.includes(language.code),
                onChange: ($event: any) => (toggleLanguage(language.code, $event))
              }, null, 40, _hoisted_64),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (selectLanguage(language.code))
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(languageDisplayLabel)(language.code)), 1)
              ], 8, _hoisted_65)
            ], 2))
          }), 128))
        ]),
        (activeDraft.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("strong", null, _toDisplayString(_unref(languageDisplayLabel)(activeLanguage.value)), 1),
                (activeLanguage.value === primaryLanguage.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, "主要语言"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", {
                class: _normalizeClass({
              'field-over-limit': isFieldOverLimit('level_name', activeDraft.value.level_name),
            })
              }, [
                _createElementVNode("span", _hoisted_69, [
                  _cache[35] || (_cache[35] = _createElementVNode("span", null, "关卡名称", -1)),
                  _createElementVNode("span", _hoisted_70, _toDisplayString(activeDraft.value.level_name.length) + "/" + _toDisplayString(fieldLimit('level_name')), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((activeDraft.value.level_name) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, activeDraft.value.level_name]
                ]),
                (isFieldOverLimit('level_name', activeDraft.value.level_name))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, " 标题最多 " + _toDisplayString(fieldLimit('level_name')) + " 个字符 ", 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass({
              'field-over-limit': isFieldOverLimit('level_intro', activeDraft.value.level_intro),
            })
              }, [
                _createElementVNode("span", _hoisted_72, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", null, "玩法说明", -1)),
                  _createElementVNode("span", _hoisted_73, _toDisplayString(activeDraft.value.level_intro.length) + "/" + _toDisplayString(fieldLimit('level_intro')), 1)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeDraft.value.level_intro) = $event)),
                  rows: "5",
                  placeholder: "请输入该语言的玩法说明"
                }, null, 512), [
                  [_vModelText, activeDraft.value.level_intro]
                ]),
                (isFieldOverLimit('level_intro', activeDraft.value.level_intro))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_74, " 玩法说明最多 " + _toDisplayString(fieldLimit('level_intro')) + " 个字符 ", 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass({
              'field-over-limit': isFieldOverLimit('desc', activeDraft.value.desc),
            })
              }, [
                _createElementVNode("span", _hoisted_75, [
                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "关卡详情", -1)),
                  _createElementVNode("span", _hoisted_76, _toDisplayString(activeDraft.value.desc.length) + "/" + _toDisplayString(fieldLimit('desc')), 1)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeDraft.value.desc) = $event)),
                  rows: "10",
                  placeholder: "请输入该语言的关卡详情"
                }, null, 512), [
                  [_vModelText, activeDraft.value.desc]
                ]),
                (isFieldOverLimit('desc', activeDraft.value.desc))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_77, " 关卡详情最多 " + _toDisplayString(fieldLimit('desc')) + " 个字符 ", 1))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_78, " 请从左侧勾选并选择一种语言开始编辑。 "))
      ])
    ])
  ]))
}
}

})